import { __decorate } from "tslib";
import { AsnProp, AsnType, AsnTypeTypes, AsnPropTypes } from "@peculiar/asn1-schema";
let ExtendedRevoke = class ExtendedRevoke {
    constructor(value = null) {
        this.value = value;
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.Null })
], ExtendedRevoke.prototype, "value", void 0);
ExtendedRevoke = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], ExtendedRevoke);
export { ExtendedRevoke };
